import { PropTypes } from 'prop-types';
import { useMemo } from 'react';
import Utils from '@/common/utils/utils';
import TooltipThumb from '../common/TooltipThumb';
import './AttachFileChatPost.css';
import { getImageLinks } from './AttachFileHandler';
function ImageAttachFile({ attachData, detailTicket, setOpenPreviewImage, setOpenFileOption, setOpenOption }) {
    const { imgThumbnailLink, imgLink } = useMemo(
        () => getImageLinks(attachData, detailTicket),
        [attachData, detailTicket]
    );

    if (!imgThumbnailLink || !imgLink) return null;    
    
    return (
        <div key={attachData.id} className="justify-content-center">
            <div className="display-thumb">
                <div className="class-relative cursor-default listmap-item image-attach-file-container">
                    <TooltipThumb
                        value={`${
                            attachData.fileInfo.fileName
                        }(${Utils.formatBytes(
                            attachData.fileInfo.fileSize
                        )})`}
                        className="titleDisplay"
                    >
                        <img
                            className="image-attach-file-thumbnail"
                            src={imgThumbnailLink}
                            alt=""
                            aria-label="more"
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            onClick={() => {
                                setOpenPreviewImage(imgLink);
                            }}
                        />
                    </TooltipThumb>
                    <div
                        className="image-attach-file-more"
                        onClick={e => {
                            setOpenFileOption(attachData);
                            setOpenOption(e.currentTarget);
                        }}
                    >
                        <img
                            src="/assets/image/icon-more-panel.svg"
                            alt=""
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

ImageAttachFile.propTypes = {
    attachData: PropTypes.any,
    detailTicket: PropTypes.any,
    setOpenPreviewImage: PropTypes.func,
    setOpenFileOption: PropTypes.func,
    setOpenOption: PropTypes.func
};

export default ImageAttachFile;

